module.exports = __webpack_public_path__ + "static/ResearchPoster-Chuah-v3-53a99d95adb72e6b65961b739dacb6d8.pdf";